// extracted by mini-css-extract-plugin
export var form = "_3r-0";